import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IncidentContainerComponent } from './containers/incident-container.component';


const routes: Routes = [
	{ path: '', component: IncidentContainerComponent }
	
];

@NgModule({
	imports: [ RouterModule.forChild(routes) ],
	exports: [ RouterModule ]
})
export class IncidentRoutingModule {}